import React from 'react';
import {InputGroup,InputGroupAddon,InputGroupText,Row,Col, Button, Card, CardBody, CustomInput} from 'reactstrap';
import brandingLogo from '../../assets/images/branding-logo.png';
import { Formik, Field, Form, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import SocialLogin from "../authentication/socialLogin";


const PreviewRememberMe = () => (
    <div style={{display: 'flex'}}>
        <CustomInput type="checkbox" id="rememberMeCheck" disabled />
        {" "}Remember Me
    </div>
);

const LoginPreview = ({ brandColor, fontFamily, logoUrl, formAlignment = 'center', displayLogo = true, signUpEnabled = false, googleOAuthEnabled = false, height = 600 }) => {
        return (
            <div
                style={{
                    height: height + 'px',
                    display: 'flex',
                    alignItems: formAlignment === 'center' ? 'center' : formAlignment === 'left' ? 'flex-start' : 'flex-end',
                    justifyContent: formAlignment === 'center' ? 'center' : formAlignment === 'left' ? 'flex-start' : 'flex-end',
                    backgroundColor: brandColor,
                    overflow: 'hidden',
                    border: '1px solid #e9ecef',
                    borderRadius: '8px',
                }}
            >
                <Card
                    style={{
                        height: formAlignment === 'center' ? 'auto' : '100%',
                        borderRadius: formAlignment === 'center' ? '12px' : '0px',
                        float: formAlignment === 'center' ? 'none' : formAlignment,
                        marginBottom: 0,
                    }}
                >
                    <CardBody>
                        <Row>
                            <Col lg="12">
                                {displayLogo &&
                                    <div className="text-center" style={{paddingTop: formAlignment === 'center' ? '0px' : '30px'}}>
                                        <img src={logoUrl || brandingLogo} alt="logo" className="img-fluid" style={{maxHeight: 100, maxWidth: 200}} />
                                    </div>
                                }
                                <div className="p-4" style={{ fontFamily }}>
                                    <h3 className="font-medium mb-3">Log In to your account</h3>
                                    <Formik
                                            initialValues={{
                                                username: '',
                                                password: ''
                                            }}
                                            render={({ errors, status, touched, isSubmitting }) => (
                                                <Form className="mt-3" id="loginform">
                                                    <InputGroup className="mb-3">
                                                        <InputGroupAddon addonType="prepend">
                                                            <InputGroupText>
                                                                <i className="ti-email"></i>
                                                            </InputGroupText>
                                                        </InputGroupAddon>

                                                        <Field name="username" type="text" className={'form-control' + (errors.username && touched.username ? ' is-invalid' : '')} />
                                                        <ErrorMessage name="username" component="div" className="invalid-feedback" />
                                                    </InputGroup>
                                                    <InputGroup className="mb-3">
                                                        <InputGroupAddon addonType="prepend">
                                                            <InputGroupText>
                                                                <i className="ti-lock"></i>
                                                            </InputGroupText>
                                                        </InputGroupAddon>
                                                        <Field name="password" type="password" className={'form-control' + (errors.password && touched.password ? ' is-invalid' : '')} />
                                                        <ErrorMessage name="password" component="div" className="invalid-feedback" />

                                                    </InputGroup>
                                                    <div className="d-flex no-block align-items-center mb-3">
                                                    <PreviewRememberMe />
                                                </div>
                                                    <Row className="mb-3">
                                                        <Col xs="12">
                                                            <Button size="lg" type="button" block style={{ backgroundColor: brandColor, borderColor: brandColor }}>Login</Button>
                                                        </Col>
                                                    </Row>
                                                    {status &&
                                                        <div className={'alert alert-danger'}>{status}</div>
                                                    }
                                                    
                                                    {
                                                        signUpEnabled &&
                                                        <div className="justify-content-center d-flex align-items-center">
                                                            <span>Don't have an account?</span>
                                                            <span style={{ paddingLeft: 6, color: brandColor, }}>Register</span>
                                                        </div>
                                                    }

                                                    <div className="justify-content-center d-flex align-items-center">
                                                        <span>Forgot password?</span>
                                                        <span style={{ paddingLeft: 6, color: brandColor }}>Reset</span>
                                                    </div>

                                                    {
                                                        googleOAuthEnabled &&
                                                        <>
                                                            <hr/>
                                                            <h4 className="text-center text-bold">Or</h4>
                                                            <SocialLogin isDisabled={true} />
                                                        </>
                                                    }
                                                </Form>
                                            )}
                                        />
                                </div>

                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            </div>
		);
};

export default LoginPreview;
